// @ts-check
import { useAuthService } from 'services/AuthService/AuthService';
import { useMemo } from 'react';
import createConvertFunctions from './createConvertFunctions';

/**
 * @typedef {import('./createConvertFunctions').ConvertCallback} ConvertCallback
 */
/**
 * @typedef {import('./createConvertFunctions').ConvertArrayCallback} ConvertArrayCallback
 */
/**
 * @typedef {'metric' | 'imperial'} Units
 */
/**
 * @return {{ units: Units, convertToUserValue: ConvertCallback, convertToSystemValue: ConvertCallback, convertToUserPairArray: ConvertArrayCallback }}
 */
const useMeasurementSystem = ({ shouldLimitDecimal = true, undefinedValueString = '-' } = {}) => {
  const { user } = useAuthService();
  /** @type {Units} */
  const units = /** @type {Units}*/(user?.settings.units) ?? 'metric';
  return useMemo(() =>
    ({ units, ...createConvertFunctions(/** @type {Units}*/(units), shouldLimitDecimal, undefinedValueString) }),
  [shouldLimitDecimal, undefinedValueString, units]);
};

export default useMeasurementSystem;
